import React, {useState} from 'react';
import { useParams } from "react-router-dom";
import Loader from '../../components/Loader';
import { useUser, isAdmin, isChief, isManager } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import {useFirestoreCollection} from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import AddItem from '../actions/AddItem';
import ToggleActivationLink from '../actions/ToggleActivationLink';

const Machines = () => {

  const { client_id, site_id, silo_id } = useParams(); // Capture l'ID du client depuis l'URL
  const { data: machines, loader } = useFirestoreCollection(`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines`);
  const [ajoutMachine, popupAjoutMachine] = useState(false);

  const typesMachines = [
    {"id":"1", value:"Transporteurs à chaîne"},
    {"id":"2", value:"Transporteurs à bande"},
    {"id":"3", value:"Élévateurs"},
    {"id":"4", value:"Vis sans fin"},
    {"id":"5", value:"Pendulaires"},
    {"id":"6", value:"Nettoyeurs et calibreurs"},
    {"id":"7", value:"Ventilateurs"},
    {"id":"8", value:"Aspiration centralisée"},
    {"id":"9", value:"Boîtes de direction"},
  ]

  //contexte de l'utilisateur connecté
  const user = useUser();

  const columns = [
    { header: 'Nom', render: (machine) => machine.nom },
    { header: 'Type', render: (machine) => machine.type},
    { header: 'Marque', render: (machine) => machine.marque},
    { header: 'Débit (t/h)', render: (machine) => machine.debit},
    { header: 'État', render: (machine) => machine.dateMaintenance ? (
      <div>
        <span
          className={`inline-block w-2.5 h-2.5 rounded-full mr-2 bg-green-500`}
        ></span>
        Réalisée le {dateFromTimestampToString(machine.dateMaintenance.seconds)}
      </div>
    ) : (
      <div>
        <span
          className={`inline-block w-2.5 h-2.5 rounded-full mr-2 bg-red-500`}
        ></span>
        Maintenance non réalisée
      </div>
    )},
    { header: 'Active', render: (machine) => (machine.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (machine) => (
      <div className='flex gap-4'>
        <ToggleActivationLink collection={`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines`} item={machine} />
        {(isChief(user.user) || isManager(user.user) && machine.rapportMaintenance) ? (
          <a
            href={machine.rapportMaintenance}
            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          >
            Rapport de maintenance
          </a>
        ) : null }
      </div>
    )}
  ];

  return (
    <div>
      {isAdmin(user.user) ? (
        <a href="#" onClick={() => popupAjoutMachine(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Ajouter une machine"} loading={false} />
        </a>
      ) : null }

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={machines} 
          columns={columns} 
          onRowClick={(machine) => window.location.href = `/client/${client_id}/site/${site_id}/silo/${silo_id}/machine/${machine.id}`}
        />
      )}

      {ajoutMachine ? (
        <AddItem
          onClose={() => popupAjoutMachine(false)}
          collectionPath={`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines`}
          title="Ajouter une machine"
          fields={[
            { name: "nom", label: "Nom de la machine", type: "text" },
            { name: "type", id:"type", label: "Type de machine", type: "select", defaultOption:"Séléctionnez le type de machine", values:typesMachines },
            { name: "marque", label: "Marque de la machine", type: "text" },
            { name: "debit", label: "Débit de la machine (t/h)", type: "text" },
          ]}
        />
      ) : null }
    </div>
  );
};

export default Machines;
